export class HostingDomainRecordData {
  id: number;
  name: string;
  port: any;
  priority: any;
  record_id: any;
  ttl: number;
  type: any;
  value: any;
  weight: any;
}

